import {
  WorkingStepDto,
  WorkingStepType,
} from 'services/APIs/InternalAPI/internal-api.contracts'
import { RootAppState } from 'store/configureStore'
import { bomItemSelector } from './bomItemSelector'

export type WorkingStepStats = {
  count: number
  primaryWorkingStep: WorkingStepType
}

export const projectPriceSummariesWorkingStepSummary = (
  state: RootAppState
) => {
  if (!state.project.priceSummaries) {
    return null
  }

  const stats: Partial<Record<WorkingStepType, WorkingStepStats>> = {}

  Object.values(state.project.priceSummaries).map((priceSummary) => {
    if (
      priceSummary?.isWorkingStep &&
      priceSummary.workingStep.primaryWorkingStep ===
        priceSummary.workingStep.secondaryWorkingStep
    ) {
      const workingStep = priceSummary.workingStep.primaryWorkingStep

      if (!stats[workingStep]) {
        stats[workingStep] = {
          count: 0,
          primaryWorkingStep: workingStep,
        }
      }

      stats[workingStep].count += 1
    }
  })

  return stats
}

export const assemblyWorkingStepsSummaryWithCounterSelector =
  (bomItemId: string, onlyAssemblyWorkingSteps?: boolean) =>
  (state: RootAppState): Record<string, WorkingStepStats> => {
    if (!bomItemId) return null

    const bomItem = bomItemSelector(state, bomItemId)

    if (bomItem?.type !== 'Assembly' && bomItem?.type !== 'Row') {
      return null
    }

    const workingStepsStats: Record<string, WorkingStepStats> = {}

    const addToStats = (workingStep: WorkingStepDto) => {
      if (workingStep.primaryWorkingStep === workingStep.secondaryWorkingStep) {
        workingStepsStats[workingStep.primaryWorkingStep] = {
          count:
            workingStepsStats[workingStep.primaryWorkingStep]?.count + 1 || 1,
          primaryWorkingStep: workingStep.primaryWorkingStep,
        }
      }
    }

    if (bomItem.type === 'Assembly') {
      bomItem.assemblyWorkingStepDtos.forEach(addToStats)

      if (!onlyAssemblyWorkingSteps) {
        bomItem.partTypeIds.forEach((partTypeId) => {
          const partType = bomItemSelector(state, partTypeId)

          if (partType?.type === 'Row') {
            partType.workingSteps.forEach(addToStats)
          }
        })
      }
    } else {
      bomItem.workingSteps.forEach(addToStats)
    }

    const sortedStats = Object.fromEntries(
      Object.entries(workingStepsStats).sort(
        ([, a], [, b]) => b.count - a.count
      )
    )

    return sortedStats
  }
